import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import _ from "lodash";
import moment from "moment-timezone";

import { candidateTypeCounts } from "@/Constants/common";
import {
  _candidatetypeCount,
  _shiftCalendar,
  _upcomingBookings,
} from "@/services/clientdashboard";
import store from "@/store";
import { handleAPICatch, isPremiumUser } from "@/utilities/utils";

import { updateTypeCount } from "./clientscandidates";
import {
  formatDashboardShiftJobs,
  formatDashboardUpcomingModal,
} from "../utilities/dataFormatter";
import { apiEncrypt } from "../utilities/keyEncryption";

const initialState = {
  upcomingBookings: [],
  upcomingBookingsLoading: false,
  isLoading: false,
  UpcomingBookedDashaboardDataModal: [],
  isDashboardUpcomingListLoading: false,

  shiftScheduleFilter: {
    search: "",
    shift_type: "month",
    shift_status: "",
    shift_date: "",
  },
  rightSideShiftScheduleFilter: {
    search: "",
    shift_type: "month",
    shift_status: "",
    shift_date: "",
  },

  shiftListingFilters: {
    candidateReferenceNo: "",
    candidateName: "",
    candidateLicenseNo: "",
    contractReferenceNo: "",
    complianceStatus: null,
    candidateRole: null,
    candidatePhoneNumber: "",
    shiftDateFrom: "",
    shiftDateTo: "",
  },
  sorting: {
    sortByColumn: "",
    sortByOrder: "",
  },
  showShiftListingFilters: false,
  oldShiftListingFilters: {},
  shiftListingPagination: {
    currentPage: 1,
    totalPage: 1,
    isLastPage: false,
  },
  shiftCalendar: [],
  expandShiftCalendar: [],
  shiftListingLoading: false,
  shiftCalendarLoading: false,
  totalShifts: 0,
  shiftListing: [],
  isCandidateTypeLoading: false,
  showUpcomingBookingsModal: false,
  showShiftScheduleModal: false,
  UpComingfilters: {
    search: "",
  },
  upComingPagination: {
    currentPage: 1,
    totalPage: 1,
    isLastPage: false,
  },
};

export const fetchUpcomingBookings = createAsyncThunk(
  "clientdashboard/fetchUpcomingBookings",
  async (data, thunkAPI) => {
    const response = _upcomingBookings(data);
    response
      .then((res) => {
        const {
          data: { total_record, upcoming_booking },
        } = res;
        let jobs = [];
        upcoming_booking.forEach((value, key) => {
          let obj = {
            is_ongoing: value.is_ongoing,
            contract_id: value.contract_id,
            route_id: apiEncrypt(value.candidate_id),
            candidate_id: value.candidate_id,
            route_contract_id: apiEncrypt(value.contract_parent_id),
            contract_client_id: value.contract_client_id,
            contract_vacancy_id: value.contract_vacancy_id,
            contract_date: value.contract_date,
            candidate_name: value.candidate_name,
            role_name: value.role_name,
            contract_start_time: value.contract_start_time,
            contract_end_time: value.contract_end_time,
            contract_ref_no: value.contract_refNo,
            contract_parent_id: value.contract_parent_id,
            contract_duration: value.contractDuration,
            profile_image: value.profile_image,
            licence_no: value.licence_no,
            profile_percent: value.profile_percent,
            break_time: value.break_time,
            candidate_email: isPremiumUser() ? value.candidate_email : null,
            mobile_phone_number: isPremiumUser()
              ? value.mobile_phone_number
              : null,
            running_late_status: isPremiumUser()
              ? value.running_late_status
              : false,
            running_late_reason: isPremiumUser()
              ? value.running_late_reason
              : null,
            is_time_started: value.is_time_started,
            logged_in_time: value.logged_in_time,
          };
          jobs.push(obj);
        });

        thunkAPI.dispatch(setUpcomingBookings(jobs));
        thunkAPI.dispatch(setUpcomingBookings(jobs));
      })
      .catch((error) => {
        // handleAPICatch(error);
      })
      .finally(() => {
        thunkAPI.dispatch(setUpcomingBookingsLoading(false));
      });
  },
);

export const fetchUpcomingCandidateDashbord = createAsyncThunk(
  "candidatesBooked/fetchUpcomingCandidateDashbord",
  async (data, { dispatch, getState }) => {
    const {
      clientDashboard: {
        UpComingfilters,
        upComingPagination,
        UpcomingBookedDashaboardDataModal,
      },
    } = getState();
    if (_.isEmpty(data)) {
      data = {
        ...UpComingfilters,
      };
    }
    if (upComingPagination.isLastPage) {
      return dispatch(setUpcomingBoookedDashboardLoading(false));
    }
    dispatch(
      setisUpcomingDashboardPaginationLoading(
        upComingPagination.currentPage !== 1,
      ),
    );
    // dispatch(toggleSelectedAll(false))
    const _data = {
      ...data,
      page: upComingPagination.currentPage,
      for_upcomming: 1,
    };
    const response = _upcomingBookings(_data);
    response
      .then((res) => {
        const {
          data: { upcoming_booking, meta },
        } = res;
        const { currentPage, lastPage, isLastPage, total: totalCount } = meta;
        const data = formatDashboardUpcomingModal(upcoming_booking);
        dispatch(
          updateDashboardUpcomingPagination({
            currentPage: currentPage + 1,
            totalPage: lastPage,
            isLastPage: isLastPage,
          }),
        );
        let prevList =
          currentPage === 1 ? [] : _.uniq(UpcomingBookedDashaboardDataModal);
        let firstContractId = data.length > 0 ? data[0].contract_id : null;
        // dispatch(updateTotalCount(totalCount))
        if (
          prevList.length > 0 &&
          prevList.find((item) => item.contract_id === firstContractId) !==
            undefined
        ) {
          //
        } else {
          dispatch(updateUpcomingBookedDashboard([...prevList, ...data]));
        }
        return res;
      })
      .catch((error) => {
        handleAPICatch(error);
      })
      .finally(() => {
        setTimeout(() => {
          dispatch(setisUpcomingDashboardPaginationLoading(false));
          dispatch(setDashboardUpcomingListLoading(false));
        }, 10);
      });
  },
);

export const fetchShiftListing = createAsyncThunk(
  "clientdashboard/fetchShiftListing",
  async (data, { dispatch, getState }) => {
    // remove below to enable api call
    dispatch(setShiftListingLoading(false));
    return;

    const { rightSideShiftScheduleFilter } = store.getState().clientDashboard;
    let paginationData = getState().clientDashboard.shiftListingPagination;

    if (paginationData.isLastPage) {
      return dispatch(setShiftListingLoading(false));
    }

    let shiftListingFilters = getState().clientDashboard.shiftListingFilters;

    const response = _shiftCalendar({
      date: rightSideShiftScheduleFilter.shift_date,
      search: rightSideShiftScheduleFilter.search,
      type: rightSideShiftScheduleFilter?.shift_type,
      currentPage: paginationData.currentPage,
      ...shiftListingFilters,
    });
    response
      .then((res) => {
        const {
          data: { job_list, meta },
        } = res;
        const { currentPage, lastPage, isLastPage, total: totalCount } = meta;
        let jobs = formatDashboardShiftJobs(job_list, currentPage);
        dispatch(
          updateShiftListingPagination({
            currentPage: currentPage + 1,
            totalPage: lastPage,
            isLastPage: isLastPage,
          }),
        );
        let newArr = [];
        Object.keys(jobs).forEach((item) => {
          let obj = jobs[item];
          newArr.push(...obj);
        });
        let prevList =
          currentPage === 1
            ? []
            : _.uniq(getState().clientDashboard.shiftListing);
        dispatch(updateShiftListing([...prevList, ...newArr]));
        return res;
      })
      .catch((error) => {
        // console.log(error);
        handleAPICatch(error);
        // return rejectWithValue(error);
      })
      .finally(() => {
        dispatch(setShiftListingLoading(false));
      });
  },
);

export const fetchShiftCalendar = createAsyncThunk(
  "clientdashboard/fetchShiftCalendar",
  async (data, { dispatch }) => {
    const { shiftScheduleFilter } = store.getState().clientDashboard;

    // remove below to enable api call
    dispatch(setShiftCalendarLoading(false));
    return;

    const response = _shiftCalendar({
      date: data.date,
      status: shiftScheduleFilter.shift_status
        ? shiftScheduleFilter.shift_status
        : "",
      for: "calendar",
      type: shiftScheduleFilter.shift_type,
    });

    response
      .then((res) => {
        const {
          data: {
            job_list,
            current_page: currentPage,
            last_page: lastPage,
            is_last_page: isLastPage,
          },
        } = res;
        let jobs = formatDashboardShiftJobs(job_list, currentPage);
        dispatch(updateShiftCalendar(jobs));
        dispatch(updateExpandShiftCalendar(jobs));
      })
      .catch((error) => {
        // console.log(error)
        handleAPICatch(error);
      })
      .finally(() => {
        setTimeout(() => {
          dispatch(setShiftCalendarLoading(false));
        }, 20);
      });
  },
);

export const fetchCandidateTypes = createAsyncThunk(
  "clientdashboard/fetchCandidateTypes",
  async (data, thunkAPI) => {
    const _data = {
      ...data,
    };
    thunkAPI.dispatch(toggleCandidateTypeLoading(true));
    const response = _candidatetypeCount(_data);
    response
      .then((res) => {
        if (res) {
          const { data } = res;
          let {
            total_client_applicant_list: applied,
            total_client_booked_list: booked,
            total_client_invitation_list: invited,
            total_client_worked_list: worked,
            total_unfilled_contracts_list: unfilled,
          } = data;
          const obj = { applied, booked, invited, worked, unfilled };
          const arr = candidateTypeCounts.map((ele) => {
            let type = ele.type;
            return {
              ...ele,
              value: obj[type],
            };
          });
          thunkAPI.dispatch(updateTypeCount(arr));
        }
      })
      .catch((error) => {
        handleAPICatch(error);
      })
      .finally(() => {
        setTimeout(() => {
          thunkAPI.dispatch(toggleCandidateTypeLoading(false));
        }, 10);
      });
  },
);

export const updateUpcomingBookingsAsync = createAsyncThunk(
  "clientdashboard/updateUpcomingBookingsAsync",
  async (_, { dispatch, getState }) => {
    const state = getState()?.clientDashboard;
    const currentTime = moment().tz("Europe/London").format("HH:mm");

    // Helper function to trigger the necessary dispatches
    const dispatchUpcomingActions = () => {
      if (state.showUpcomingBookingsModal) {
        dispatch(
          updateDashboardUpcomingPagination({
            ...state.upComingPagination,
            currentPage: 1,
            isLastPage: false,
          }),
        );
        dispatch(fetchUpcomingCandidateDashbord({}));
      }
      dispatch(fetchUpcomingBookings({ for_upcoming: 0 }));
    };

    state.upcomingBookings.forEach((booking) => {
      const contractTime = moment(
        booking.contract_start_time,
        "HH:mm:ss",
      ).format("HH:mm");
      const contractEndTime = moment(booking.contract_end_time, "HH:mm:ss")
        .add(1, "minute")
        .format("HH:mm"); // Add 1 minute
      // Combined condition for both contract start and end time checks
      if (
        (contractTime === currentTime && booking?.is_time_started === 0) ||
        (contractEndTime === currentTime &&
          (booking?.is_ongoing === 1 ||
            booking?.is_time_started === 1 ||
            booking?.running_late_status === 1))
      ) {
        dispatchUpcomingActions();
      }
    });
  },
);

const clientDashboardSlice = createSlice({
  name: "clientdashboard",
  initialState,

  reducers: {
    /**
     * Set upcoming bookings in the state and update loading status.
     *
     * @param {type} state - the current state
     * @param {type} action - the action containing the payload
     * @return {type} undefined
     */
    setUpcomingBookings: (state, action) => {
      state.upcomingBookings = action.payload;
      state.isLoading = false;
    },
    setUpcomingBookingsLoading: (state, action) => {
      state.upcomingBookingsLoading = action.payload;
    },
    /**
     * Sets the loading state based on the action payload.
     *
     * @param {type} state - the current state
     * @param {type} action - the action object
     * @return {type} the updated state
     */
    setLoading: (state, action) => {
      state.isLoading = action.payload;
    },
    toggleShowUpcomingBookingViewModal: (state, action) => {
      state.showUpcomingBookingsModal = action.payload;
    },
    /**
     * Update the shift schedule filter based on the given action payload.
     *
     * @param {object} state - the current state
     * @param {object} action - the action object containing the payload
     */
    updateShiftScheduleFilter: (state, action) => {
      if (_.isEmpty(action.payload)) {
        state.shiftScheduleFilter = initialState.shiftScheduleFilter;
      } else {
        state.shiftScheduleFilter = {
          ...state.shiftScheduleFilter,
          ...action.payload,
        };
      }
    },
    updateRightShiftScheduleFilter: (state, action) => {
      if (_.isEmpty(action.payload)) {
        state.rightSideShiftScheduleFilter =
          initialState.rightSideShiftScheduleFilter;
      } else {
        state.rightSideShiftScheduleFilter = {
          ...state.rightSideShiftScheduleFilter,
          ...action.payload,
        };
      }
    },
    //
    /**
     * Update the shift listing in the state.
     *
     * @param {type} state - the current state
     * @param {type} action - the action containing the new shift listing payload
     * @return {type} undefined
     */
    updateShiftListing: (state, action) => {
      state.shiftListing = action.payload;
    },

    /**
     * Set the loading state for the shift listing.
     *
     * @param {type} state - The state object
     * @param {type} action - The action object
     * @return {type}
     */
    setShiftListingLoading: (state, action) => {
      state.shiftListingLoading = action.payload;
    },
    setShiftCalendarLoading: (state, action) => {
      state.shiftCalendarLoading = action.payload;
    },
    /**
     * Update the shift calendar in the state with the provided payload.
     *
     * @param {type} state - the current state
     * @param {type} action - the action containing the payload
     * @return {type} undefined
     */
    updateShiftCalendar: (state, action) => {
      state.shiftCalendar = action.payload;
    },
    updateExpandShiftCalendar: (state, action) => {
      state.expandShiftCalendar = action.payload;
    },
    /**
     * Function to display a pop-up for a specific row in the state.
     *
     * @param {Object} state - the current state object
     * @param {Object} action - the action object containing the payload
     * @return {void}
     */
    displayRowPopUp: (state, action) => {
      let rowId = action.payload.rowID;
      let show = action.payload.show;
      state.shiftListing = state.shiftListing.map((ele) => {
        return { ...ele, showpopup: ele.row_id == rowId ? show : false };
      });
    },
    /**
     * Updates the shift listing pagination based on the provided action payload.
     *
     * @param {object} state - The current state object
     * @param {object} action - The action object containing the payload
     * @return {void}
     */
    updateShiftListingPagination: (state, action) => {
      state.shiftListingPagination = {
        ...state.shiftListingPagination,
        ...action.payload,
      };
    },
    /**
     * Toggles the loading state for the candidate type.
     *
     * @param {object} state - The current state object
     * @param {boolean} action.payload - The new loading state value
     * @return {void}
     */
    toggleCandidateTypeLoading: (state, action) => {
      state.isCandidateTypeLoading = action.payload;
    },
    showShiftListingFilterModal: (state, action) => {
      if (action.payload) {
        state.oldShiftListingFilters = state.shiftListingFilters;
      }
      state.showShiftListingFilters = action.payload;
    },
    updateShiftListingFilters: (state, action) => {
      if (_.isEmpty(action.payload)) {
        state.shiftListingFilters = initialState.shiftListingFilters;
        return;
      } else {
        state.shiftListingFilters = {
          ...state.shiftListingFilters,
          ...action.payload,
        };
      }
    },
    updateShiftListingSorting: (state, action) => {
      state.sorting = action.payload;
    },
    reStateFilters: (state, action) => {
      state.shiftListingFilters = state.oldShiftListingFilters;
    },
    resetDashboard: (state) => {
      state.shiftScheduleFilter = initialState.shiftScheduleFilter;

      state.shiftListing = [];
      state.shiftListingPagination = initialState.shiftListingPagination;
      state.shiftListingFilters = initialState.shiftListingFilters;
      // state.shiftListingLoading = false;

      state.shiftCalendar = [];
      // state.shiftCalendarLoading = false;

      state.upcomingBookings = [];
      // state.upcomingBookingsLoading = false;
    },
    toggleShowShiftScheduleModal: (state, action) => {
      state.showShiftScheduleModal = action.payload;
    },
    updateUpcomingBookedDashboard: (state, action) => {
      state.UpcomingBookedDashaboardDataModal = action.payload;
    },
    setDashboardUpcomingListLoading: (state, action) => {
      state.isDashboardUpcomingListLoading = action.payload;
    },
    setisUpcomingDashboardPaginationLoading(state, action) {
      state.isUpcomingDashboardPaginationLoading = action.payload; // New reducer for pagination loading
    },
    updateDashboardUpcomingFilters: (state, action) => {
      if (_.isEmpty(action.payload)) {
        state.UpComingfilters = {
          search: state.UpComingfilters.search,
          ...initialState.UpComingfilters,
        };
        return;
      } else {
        if (action.payload.reset) {
          state.UpComingfilters = initialState.UpComingfilters;
        } else {
          state.UpComingfilters = {
            ...state.UpComingfilters,
            ...action.payload,
          };
        }
      }
    },
    updateDashboardUpcomingPagination: (state, action) => {
      state.upComingPagination = {
        ...state.pagination,
        ...action.payload,
      };
    },

    updateUpcomingBookings: (state, action) => {
      // const currentTime = moment().tz("Europe/London").format("HH:mm"); // Get London time
      // state.upcomingBookings.forEach((booking) => {
      //   const contractTime = moment(booking.contract_start_time, "HH:mm:ss").format("HH:mm");
      //   const contractEndTime = moment(booking.contract_end_time, "HH:mm:ss").format("HH:mm");
      //   // Update booking if the current time matches the contract start time
      //   booking.is_time_started = contractTime == currentTime && booking.is_time_started == 0 ? 1 : booking.is_time_started;
      //   // Optionally update booking's end time state
      //   // booking.is_time_ended = contractEndTime === currentTime ? 1 : dispatch(fetchUpcomingBookings({ for_upcoming: 0 }));;
      //   if (contractTime === currentTime) {
      //     dispatch(fetchUpcomingBookings({ for_upcoming: 0 }));
      //   }
      // });
    },
  },
});

export const {
  setUpcomingBookings,
  setUpcomingBookingsLoading,
  setLoading,
  toggleShowUpcomingBookingViewModal,
  updateExpandShiftCalendar,
  updateShiftScheduleFilter,
  updateShiftListingSorting,
  updateShiftListing,
  setShiftListingLoading,
  setShiftCalendarLoading,
  updateShiftCalendar,
  displayRowPopUp,
  toggleShowShiftScheduleModal,
  updateShiftListingPagination,
  toggleCandidateTypeLoading,
  showShiftListingFilterModal,
  updateShiftListingFilters,
  reStateFilters,
  resetDashboard,
  updateRightShiftScheduleFilter,
  updateUpcomingBookedDashboard,
  setDashboardUpcomingListLoading,
  setisUpcomingDashboardPaginationLoading,
  updateDashboardUpcomingFilters,
  updateDashboardUpcomingPagination,
  updateUpcomingBookings,
} = clientDashboardSlice.actions;

export default clientDashboardSlice.reducer;
